import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import BuyersByItemsAndProductsSectionContainer from '../containers/BuyersByItemsAndProductsSection/BuyersByItemsAndProductsSection.container'
import BuyersProvidersSizeSectionContainer from '../containers/BuyersProvidersSizeSection/BuyersProvidersSizeSection.container'
import BuyersSectorsContainer from '../containers/BuyersSectors/BuyersSectors.container'
import BuyersTradedAmountsSectionContainer from '../containers/BuyersTradedAmountsSection/BuyersTradedAmountsSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'

/**
 * The Buyers' page.
 */
const Buyers = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.organizations} />
    <SearchBuyerPanelContainer />
    <BuyersSectorsContainer />
    <BuyersByItemsAndProductsSectionContainer />
    <BuyersTradedAmountsSectionContainer />
    <BuyersProvidersSizeSectionContainer />
  </BrandLayout>
)

export default Buyers
